import React, {useState, useEffect} from "react";
import {useNavigate, useLocation, Link} from "react-router-dom";
import axios from "axios";
import  {search_golfer, update_hs_cart_stage} from "../API/APICalls";
import ContactUSGA from "./ContactUSGA";



export default function VerifyForm() {

    const navigate = useNavigate();
    const location = useLocation();

    const zipcodesearch = location.state.zipcode;

    const agadata = location.state.aga;
    let golferdata = location.state.inputs;

    const [zipcode, setZipcode] = useState(zipcodesearch);
    const [inputs, setInputs] = useState({firstname: '', lastname: golferdata.lastname || '', phone: '', email: '', dob: '', sex: '', address: '', address2: '', city:'', state:'', zip: '', handicapID:'', contact: ''});


    const [disable, SetDisable] = useState(false);
    const [disableemail, SetDisableEmail] = useState(false);
    const [required, setRequired] = useState(false);
    const [requiredemail, setRequiredEmail] = useState(true);
    const handleChange = ({ target: { name, value } }: { target: { name: string, value: string } }) =>  setInputs(inputs => ({ ...inputs, [name]: value }));
    const [isLoading, setIsLoading] = useState(true);
    const [contactUSGA, setContactUSGA] = useState(false);
    const [message, setMessage] = useState('');
    const [propertyUsed, setPropertyUsed] = useState('');

    

      const handleFields = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        
        if (event.currentTarget.value)
        {
            SetDisable(true);
            
        } else {
            SetDisable(false);
        }
    }

    const handleHandicap = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        
        if (event.currentTarget.value)
        {
            SetDisableEmail(true);
        } else {
            SetDisableEmail(false);
        }
    }

    const handlePastedEmail = (event:React.ClipboardEvent<HTMLInputElement>) => {    
        
        if (event.currentTarget.value)
        {
            SetDisable(false);
        } else {
            SetDisable(true);
        }
    }


     const formatHandicapPasted = (event:React.ClipboardEvent<HTMLInputElement>) => {     

        if (event.currentTarget.value)
            {
                SetDisableEmail(false);
                setRequired(false);
            } else {
                SetDisableEmail(true);
                setRequired(true);
            }
        }

    
      const disableField = async (event: React.KeyboardEvent<HTMLInputElement>) => {
        setInputs({... inputs, "email": event.currentTarget.value });
        
        if (inputs.email.length === 0)
        {
            
            SetDisable(false);
            setRequired(false);
            setRequiredEmail(false);
        } else {
            SetDisable(false);
            setRequired(true);
            setRequiredEmail(true);
        }
        
      }


     const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);
        const search_response = "";
        const search_cc_response = "";

        //search centralized computation for golfer lastname and email or handicap id
        
       
        const response = await search_golfer(inputs, agadata[0].aga_id, agadata[0]);

        if (response)
        {
            var status_code = JSON.parse(response);
            //console.log(JSON.parse(status_code.results[0].golfers.length));
            if (status_code.error?.message === "Request failed with status code 500")
            {
                setMessage("Re-enter the information and try again.");
            } else {        

        if ((JSON.parse(response || '').golfer_profile == 0 && JSON.parse(response || '').propertyUsed=="email"))
        {
            inputs.contact = JSON.parse(response || '').hs_contact_id;
            navigate('/personal-info', {replace:true, state:{zipcode:zipcode, aga:agadata, inputs:inputs}});
        
        } else if (JSON.parse(response || '').golfer_profile == 0 && JSON.parse(response || '').propertyUsed == "golfer_id") 
        {
            setIsLoading(false);
            //setContactUSGA(true)
            setMessage("Re-enter the information and try again.");
        
        } else if (JSON.parse(response || '').findhsgolfers.results[0]?.properties.customer_source == "The Grint" && JSON.parse(response || '').status != "Inactive") 
        {
                    setIsLoading(false);
                   // setContactUSGA(true)
                    setMessage("Your membership was purchased directly through the Grint. Please reach out to them about your account, contactus@thegrint.com.");
                
        } else if (JSON.parse(response || '').golfer_profile > 0 && JSON.parse(response || '').golferContactStatus==false) 
        {
            //no email addresss found for golfer in CC
            setIsLoading(false);
            //setContactUSGA(true)
            setMessage("Re-enter the information and try again.");
        
        } else {
            inputs.contact = JSON.parse(response || '').hs_contact_id;
            navigate('/personal-lookup-verify', {replace:true, state:{zipcode:zipcode, aga:agadata, inputs:inputs, propertyUsed: JSON.parse(response || '').propertyUsed}});
        }

    }
     }
    }



     useEffect(() => {
        setIsLoading(false);
        
        
    }, [inputs]);


    return (<>
          <div className="container page_container mb-5 pb-1">
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mx-auto">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"><h1 className="fs-1 text-left">Personal Information</h1></div>

        <div className="row col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">   
                <div className="col-sm-12 col-md-12 col-lg-12">
                   <p className="mt-3 mb-2 fs-5"><span className="fs-5">Enter your last name and either your email or Handicap ID (e.g., GHIN#) to start the registration.</span></p>
                </div>
                
                
                
                <form onSubmit={handleSubmit} name="Find Golfer">
                
              
                {isLoading ?
                    <div className="loaderWrapper">
                    <div className="loader"></div>
                    </div>
                    : <><div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-2">
                            <label className="form-label">Last Name* (required)</label>
                            <input type="text" name="lastname" className="form-control" id="lastname" placeholder="" autoFocus value={inputs.lastname} pattern="^[a-zA-Z\/‘’'\-\w+ ?]+|[^@$^%*&#!]+^[^\x20-\x7F]$" onChange={handleChange} required={true} onInvalid={(e) =>
    e.currentTarget.setCustomValidity('Please enter valid Last Name.')
  } onInput={(e) => e.currentTarget.setCustomValidity('')}/>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-2">
                            <label className="form-label">Email Address{disable ? '*' : ''}</label>
                            <input type="email" name="email" className="form-control" id="email" placeholder="" value={inputs.email} onChange={handleChange} required={requiredemail} disabled={disableemail} onKeyUp={handleFields} onPaste={handlePastedEmail} pattern="[\-a-zA-Z0-9_+\}\{'?]+(\.[\-a-zA-Z0-9_+\}\{'?]+)*@[a-zA-Z0-9_][\-a-zA-Z0-9_]*(\.[\-a-zA-Z0-9_]+)*\.[a-zA-Z]*(:[0-9]{1,5})?" onInvalid={(e) =>
    e.currentTarget.setCustomValidity('Please enter valid Email Address.')
  } onInput={(e) => e.currentTarget.setCustomValidity('')}/>
                        </div></>
                    }
                        
                     
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 py-2">
                                <label className="form-label">Already have a Handicap ID? Enter it below.{disableemail ? '*' : ''}</label>
                                <input type="number" className="form-control" value={inputs.handicapID} id="handicapID" onChange={handleChange} placeholder="" name="handicapID"  disabled={disable} required={required} onKeyUp={handleHandicap} onPaste={formatHandicapPasted} />
                            </div>
                   
                    
                            {message ? <h3 className="py-3 text-left text-danger"><i className="bi bi-exclamation-circle"></i> {message}</h3>
                         : ''
                        }          


                      
                        <div className="mt-4 col-12 col-sm-12 col-md-12 col-lg-9 col-lg-12">
                            <div className="row">
                            <div className="col-12 col-sm-6 col-md-6 order-1 pt-3 ps-2">
                                <Link replace={true} to="/register" state={{zipcode:zipcode, aga:agadata, inputs:inputs}} className="w-100 btn btn-outline-secondary btn-lg rounded-pill px-5 " type="button">
                                    BACK
                                </Link>
                            </div>
                            <div className="col-12 col-sm-6 col-md-6 order-sm-1 order-lg-1 pt-3">
                                <button className="btn btn-primary w-100 btn-lg px-5 rounded-pill" type="submit">
                                    CONTINUE
                                </button>
                            </div>
                        </div>
                        </div>
                        
                        
                        </form>
                   
            </div>
            </div>
        </div>
        </>
    );

}